import {
	AUTH_REQUEST,
	AUTH_ERROR,
	AUTH_SUCCESS,
	AUTH_LOGOUT, AUTH_DOCUID, FULL_LOGOUT
} from 'actions/authentication'
import {REQUEST_PERMISSIONS, USER_REQUEST} from 'actions/user'
import {UPLOAD_USER_LOCALISATION} from "actions/localization";
import { TOKEN_UPDATE } from 'actions/token'
import Vue from 'vue'
import http from 'utils/http'
import { APPLICATION_INFO } from 'actions/application'
import { CONFIGURATIONS_INIT } from 'actions/configurations'
import router from '@/router'

const state = {
	token: localStorage.getItem('user-token') || '',
	status: '',
	applicationInfo: JSON.parse(localStorage.getItem('application-info')) || {},
	oAuthStatus: false
}

const getters = {
	isAuthenticated: state => !!state.token,
	authStatus: state => state.status,
	token: state => state.token,
	getApplicationInfo: state => state.applicationInfo,
	getOAuthStatus: state => state.oAuthStatus
}

const actions = {
	[AUTH_REQUEST]: ({commit, dispatch}, user) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST)
			http.post('/auth/authenticate', user)
				.then(resp => {
					dispatch('SET_TOKEN', resp.headers.authorization)
					dispatch(APPLICATION_INFO)
					dispatch(CONFIGURATIONS_INIT)
					dispatch(USER_REQUEST)
					dispatch(UPLOAD_USER_LOCALISATION)
					dispatch(REQUEST_PERMISSIONS)
					resolve()
				})
				.catch(err => {
					commit(AUTH_ERROR, err)
					reject(err.data.message)
					localStorage.removeItem('user-token')
					localStorage.removeItem('user-profile')
				})
		})
	},
	[AUTH_DOCUID]: ({commit, dispatch}, token) => {
		return new Promise(async (resolve, reject) => {
			commit(AUTH_REQUEST)
			await dispatch(APPLICATION_INFO)
			await dispatch(CONFIGURATIONS_INIT).then(() => {
				dispatch('SET_OAUTH_STATUS', false)
			})
			await dispatch(USER_REQUEST)
			await dispatch(UPLOAD_USER_LOCALISATION)
			await dispatch(REQUEST_PERMISSIONS)
			resolve()
		})
	},
	'SET_TOKEN': ({commit, dispatch}, token) => {
		localStorage.setItem('user-token', token)
		commit(AUTH_SUCCESS, token)
	},
	[AUTH_LOGOUT]: ({commit}) => {
		return new Promise(resolve => {
			console.log('logout')
			commit(AUTH_LOGOUT)
			resolve()
		})
	},
	[FULL_LOGOUT]: ({dispatch}) => {
		http.get('/full-logout')
			.then(() => {
				dispatch(AUTH_LOGOUT).then(() => {
					location.reload()
				})
			})
			.catch(error => {
				console.log(error)
				// Vue.rollbar.error('LOGOUT', error)
			})
	},
	[TOKEN_UPDATE]: ({ commit }, token) => {
		commit(TOKEN_UPDATE, token)
	},
	[APPLICATION_INFO]: ({ commit }) => {
		return http.get('/api-application-info')
			.then((resp) => {
				commit(APPLICATION_INFO, resp.data)
			})
			.catch(error => {
				console.log(error)
				Vue.rollbar.error('APPLICATION_INFO', error)
			})
	},
	'SET_OAUTH_STATUS': ({commit}, status) => {
		commit('SET_OAUTH_STATUS', status)
	}
}

const mutations = {
	'SET_OAUTH_STATUS': (state, status) => {
		state.oAuthStatus = status
	},
	[AUTH_REQUEST]: state => {
		state.status = 'loading'
	},
	[AUTH_SUCCESS]: (state, token) => {
		state.status = 'success'
		state.token = token
	},
	[AUTH_ERROR]: (state, err) => {
		state.status = 'error'
		Vue.rollbar.error('AUTH_REQUEST', err)
	},
	[AUTH_LOGOUT]: state => {
		state.status = ''
		state.token = ''
		state.applicationInfo = {}
		state.login = ''
		localStorage.clear()
	},
	[TOKEN_UPDATE]: (state, token) => {
		localStorage.setItem('user-token', token)
		Vue.set(state, 'token', token)
	},
	[APPLICATION_INFO]: (state, info) => {
		state.applicationInfo = info
		localStorage.setItem('application-info', JSON.stringify(info))
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
